//SearchPaging.tsx =================================================
import "../Util/Prototypes";

import * as GetSearchResults from "../Search/GetSearchResults";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";

import { Fab, Icon, Typography } from "@mui/material";

import React from "react";

//Render function.
interface iProps {
}

export function Render(props: iProps) {
   Util.logMsg("Top of SearchPaging Render");
   const lay: Search.iLayer = Search.layers[Search.activeLayerIndex];

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      //Util.logMsg("SearchPaging mounted");
   }, []);

   //Get previous page.
   function getPrevPage() {
      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();

      lay.begRec -= Settings.maxRecordCount;
      lay.endRec = lay.begRec + Settings.maxRecordCount - 1;
      lay.numRec = Settings.maxSearchRecPerPage;
      setTimeout(function () { GetSearchResults.displayResults(false); }, 100); //Wait for spinner to render.
   }

   //Get next page.
   function getNextPage() {
      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();

      lay.begRec += Settings.maxRecordCount;
      lay.endRec = Math.min(lay.begRec + Settings.maxRecordCount, lay.totRec) - 1;
      lay.numRec = Math.min(lay.totRec - lay.begRec, Settings.maxSearchRecPerPage);

      if (lay.IDs.length >= lay.endRec + 1) {
         setTimeout(function () { GetSearchResults.displayResults(false); }, 100); //Wait for spinner to render.

      } else {
         GetSearchResults.executeNextQueryTask();
      }
   }

   //Set results message.
   let fromToMsg: string = "";

   //Set component visibility.
   let prevVisible: boolean = false;
   let nextVisible: boolean = false;

   let prevDisabled: boolean = true;
   let nextDisabled: boolean = true;

   if (lay.totRec > Settings.maxRecordCount) {
      prevVisible = true;
      nextVisible = true;
      fromToMsg = (lay.begRec + 1).toLocaleString() + " to " + (lay.endRec + 1).toLocaleString() + " of " + lay.totRec.toLocaleString();
   }

   if (lay.begRec > 0) {
      prevDisabled = false;
   }

   if (lay.totRec > lay.endRec + 1) {
      nextDisabled = false;
   }

   //Render components
   if (fromToMsg === "") {
      return (<span />);

   } else {
      return (
         <div className="app-flex-row-center" style={{ marginTop: 7, marginBottom: 4 }}>
            {prevVisible &&
               <Fab size="small" color="default" disabled={prevDisabled} onClick={getPrevPage} title="Previous page" aria-label="Prev page">
                  <Icon color="action">navigate_before</Icon>
               </Fab>
            }

            <Typography variant="body2" style={{ marginLeft: 15, marginRight: 15 }}>{fromToMsg}</Typography>

            {nextVisible &&
               <Fab size="small" color="default" disabled={nextDisabled} onClick={getNextPage} title="Next/Download page" aria-label="Next page">
                  <Icon color="action">navigate_next</Icon>
               </Fab>
            }
         </div>
      ); //end return.
   }

} //end function.
